module.exports = __webpack_public_path__ + "fecc8a4063b7190f1e2423fc78b84cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/title-bg.jpg
// module id = 450
// module chunks = 0